(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zp-car-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('zp-car-photo-preview')){
customElements.define('zp-car-photo-preview',class extends HTMLElement{
connectedCallback(){
this.map=JSON.parse(this.querySelector('[data-photo-map]').textContent);this.prices=JSON.parse(this.querySelector('[data-price-map]').textContent);
this.canvas=this.querySelector('canvas');this.ctx=this.canvas.getContext('2d');this.form=this.closest('form');
this.number=this.querySelector('[data-number]');this.name=this.querySelector('[data-name]');this.checkbox=this.querySelector('[data-add-name]');this.images={};this.last='';this.side='front';
try{const s=JSON.parse(sessionStorage.getItem('zp-car-personalisation')||'{}');this.number.value=(s.number||'').slice(0,12);this.name.value=(s.name||'').slice(0,12);this.checkbox.checked=!!s.checked;}catch(e){}
this.onInput=()=>{this.number.setCustomValidity('');this.name.setCustomValidity('');this.querySelector('[data-error]').hidden=true;this.persist();this.update();};this.onSubmit=e=>this.submit(e);this.onClick=e=>{if(e.target.closest('[type=submit]'))this.submit(e);};this.onPageShow=()=>{this.busy=false;this.form.querySelectorAll('[type=submit]').forEach(b=>b.disabled=false);};window.addEventListener('pageshow',this.onPageShow);
this.querySelectorAll('button[data-side]').forEach(b=>b.addEventListener('click',()=>{this.side=b.dataset.side;this.update();}));
this.form.addEventListener('input',this.onInput);this.form.addEventListener('change',this.onInput);this.form.addEventListener('submit',this.onSubmit,true);this.form.addEventListener('click',this.onClick,true);
this.timer=setInterval(()=>this.update(),250);this.update();
}
disconnectedCallback(){clearInterval(this.timer);this.form.removeEventListener('input',this.onInput);this.form.removeEventListener('change',this.onInput);this.form.removeEventListener('submit',this.onSubmit,true);this.form.removeEventListener('click',this.onClick,true);window.removeEventListener('pageshow',this.onPageShow);}
persist(){try{sessionStorage.setItem('zp-car-personalisation',JSON.stringify({number:this.number.value,name:this.name.value,checked:this.checkbox.checked}));}catch(e){}}
update(){
const id=this.form.querySelector('[name=id]')?.value||this.dataset.initial,c=this.map[id]||this.map[this.dataset.initial];if(!c)return;
this.number.value=this.number.value.toUpperCase().slice(0,12);this.name.value=this.name.value.slice(0,12);const number=this.number.value,name=this.name.value,checked=this.checkbox.checked;
this.name.disabled=!checked;this.name.required=checked;this.querySelector('[data-name-wrap]').hidden=!checked;this.querySelector('button[data-side=back]').hidden=!checked;
if(!checked)this.side='front';if(checked&&!this.wasChecked)this.side='back';this.wasChecked=checked;
this.querySelectorAll('button[data-side]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.side===this.side)));
this.querySelector('[data-back-note]').hidden=this.side!=='back';this.querySelector('[data-empty]').hidden=!!number.trim();this.querySelector('[data-filled]').hidden=!number.trim();
this.querySelectorAll('[data-fee-row]').forEach(el=>el.hidden=!checked);
const price=this.prices[id]||Number(this.dataset.price),format=v=>new Intl.NumberFormat('en-IN',{style:'currency',currency:this.dataset.currency||'INR',maximumFractionDigits:0}).format(v/100);
this.querySelector('[data-base-price]').textContent=format(price);this.querySelector('[data-total-price]').textContent=format(price+(checked?9900:0));this.querySelector('[data-brand-label]').textContent=c.brand;
const text=this.side==='back'?name:number,key=id+'|'+number+'|'+name+'|'+checked+'|'+this.side;if(key===this.last)return;
this.last=key;this.dataset.brand=c.brand;this.dataset.number=number;this.canvas.setAttribute('aria-label',c.brand+' — '+this.side+' — '+text);
if(this.images[id]?.complete&&this.images[id].naturalWidth){this.draw(id,c,text);return;}
if(!this.images[id]){const img=new Image();this.images[id]=img;img.crossOrigin='anonymous';img.onload=()=>{this.last='';this.update();};img.onerror=()=>{this.dataset.error='image';};img.src=c.url;}
}
draw(id,c,text){
const ctx=this.ctx,back=this.side==='back';ctx.setTransform(1,0,0,1,0,0);ctx.clearRect(0,0,1600,1600);ctx.save();if(back){ctx.translate(1600,0);ctx.scale(-1,1);}ctx.drawImage(this.images[id],0,0,1600,1600);ctx.restore();
const [cx,cy,width,maxSize,slope,height]=c.n;ctx.save();ctx.translate(back?1600-cx:cx,cy);ctx.rotate(Math.atan(back?-slope:slope));let size=maxSize,bounds;const padding=12,usableWidth=width-padding*2,usableHeight=height-padding;
ctx.font='bold '+size+'px Arial';bounds=ctx.measureText(text);const inkWidth=Math.max(bounds.width,(bounds.actualBoundingBoxLeft||0)+(bounds.actualBoundingBoxRight||0)),inkHeight=(bounds.actualBoundingBoxAscent||size*.72)+(bounds.actualBoundingBoxDescent||0);size*=Math.min(1,usableWidth/Math.max(1,inkWidth),usableHeight/Math.max(1,inkHeight));ctx.font='bold '+size+'px Arial';ctx.textAlign='center';ctx.textBaseline='alphabetic';ctx.fillStyle='#292b2d';bounds=ctx.measureText(text);const ascent=bounds.actualBoundingBoxAscent||size*.72,descent=bounds.actualBoundingBoxDescent||0,offset=((bounds.actualBoundingBoxLeft||bounds.width/2)-(bounds.actualBoundingBoxRight||bounds.width/2))/2;ctx.fillText(text,offset,(ascent-descent)/2);ctx.restore();this.dataset.side=this.side;this.dataset.ready=id;
}
async submit(e){
e.preventDefault();e.stopImmediatePropagation();this.form=e.target.closest('form')||this.closest('form');this.number=this.querySelector('[data-number]');this.name=this.querySelector('[data-name]');this.checkbox=this.querySelector('[data-add-name]');if(this.busy)return;this.number.value=this.number.value.trim().toUpperCase();this.name.value=this.name.value.trim();
this.number.setCustomValidity(this.number.value?'':this.dataset.errorNumber);this.name.setCustomValidity(this.checkbox.checked&&!this.name.value?this.dataset.errorName:'');if(!this.form.reportValidity())return;
this.busy=true;const buttons=Array.from(this.form.querySelectorAll('[type=submit]'));buttons.forEach(b=>b.disabled=true);
const id=Number(this.form.querySelector('[name=id]').value||this.dataset.initial),quantity=Math.max(1,Number(this.form.querySelector('[name=quantity]')?.value)||1),properties={'Your vehicle number':this.number.value};
if(this.checkbox.checked){properties['Your Name (Back Side)']=this.name.value;properties['Back-side name engraving']='₹99 per keychain';}
const items=[{id,quantity,properties}];if(this.checkbox.checked)items.push({id:71449790546173,quantity,parent_id:id,properties:{'For vehicle number':this.number.value,'Back-side name':this.name.value}});
try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||this.dataset.errorCart);this.persist();window.location.assign(root+'cart');}
catch(error){const el=this.querySelector('[data-error]');el.textContent=error.message||this.dataset.errorCart;el.hidden=false;this.busy=false;buttons.forEach(b=>b.disabled=false);}
}
});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zp-personalise"] && !Shopify.designMode) return;
  try {
    (function () {
    var MAX = 20 * 1024 * 1024;
    function setup(root) {
      if (root.__zpPz) return;
      root.__zpPz = true;
      root.classList.add('zp-pz--ready');
      var slots = Array.prototype.slice.call(root.querySelectorAll('[data-zp-pz-slot]'));
      var more = root.querySelector('[data-zp-pz-more]');
      var err = root.querySelector('[data-zp-pz-err]');
      function filled(s) { var f = s.querySelector('[data-zp-pz-file]'); return f && f.files && f.files.length > 0; }
      function refresh() {
        if (!more) return;
        var visible = slots.filter(function (s) { return !s.hidden; });
        var allFilled = visible.every(filled);
        more.hidden = !(allFilled && visible.length < slots.length);
      }
      function clear(s) {
        var f = s.querySelector('[data-zp-pz-file]');
        f.value = '';
        s.classList.remove('is-filled');
        s.querySelector('.zp-pz__done').hidden = true;
        var img = s.querySelector('[data-zp-pz-thumb]');
        if (img.src) { try { URL.revokeObjectURL(img.src); } catch (e) {} img.removeAttribute('src'); }
      }
      slots.forEach(function (s, i) {
        var f = s.querySelector('[data-zp-pz-file]');
        f.addEventListener('change', function () {
          if (err) err.hidden = true;
          var file = f.files && f.files[0];
          if (!file) { clear(s); refresh(); return; }
          if (file.size > MAX) {
            clear(s);
            if (err) { err.textContent = 'That photo is over 20 MB. Please choose a smaller one, or WhatsApp it to us after ordering.'; err.hidden = false; }
            refresh();
            return;
          }
          s.classList.add('is-filled');
          s.querySelector('.zp-pz__done').hidden = false;
          s.querySelector('[data-zp-pz-name]').textContent = file.name;
          var img = s.querySelector('[data-zp-pz-thumb]');
          try { img.src = URL.createObjectURL(file); } catch (e) {}
          refresh();
        });
        s.querySelector('[data-zp-pz-remove]').addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          clear(s);
          if (i > 0) s.hidden = true;
          refresh();
        });
      });
      if (more) more.addEventListener('click', function () {
        var next = slots.find(function (s) { return s.hidden; });
        if (next) { next.hidden = false; next.querySelector('[data-zp-pz-file]').click(); }
        refresh();
      });
      var input = root.querySelector('[data-zp-pz-input]');
      var count = root.querySelector('[data-zp-pz-count]');
      if (input && count) input.addEventListener('input', function () {
        if (input.hasAttribute('data-zp-pz-caps')) { var p = input.selectionStart; input.value = input.value.toUpperCase(); try { input.setSelectionRange(p, p); } catch (e) {} }
        count.textContent = input.value.length + '/' + (input.maxLength > 0 ? input.maxLength : 60);
      });
      // Empty photo slots and an empty text box are left out of Add to cart, so the order only shows what was filled in.
      var form = root.closest('form');
      if (form) form.addEventListener('submit', function () {
        var off = [];
        root.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(function (el) {
          var empty = el.type === 'file' ? !(el.files && el.files.length) : !el.value.trim();
          if (empty && !el.disabled) { el.disabled = true; off.push(el); }
        });
        setTimeout(function () { off.forEach(function (el) { el.disabled = false; }); }, 1500);
      }, true);
      refresh();
    }
    // Boxes switched on by product words wait until the page has loaded, then show only if no other personaliser
    // (Zepto, HulkApps, UploadKit, theme previews) is on the page. If one turns up later, the box hides again.
    var OTHER = '.pplr-wrapper, .product-personalizer, .hulkapps_option, .uploadkit-uploader, zp-car-photo-preview, .zp-np, .zp-kp, .zp-gp';
    function otherShown() {
      var els = document.querySelectorAll(OTHER);
      for (var i = 0; i < els.length; i++) { if (els[i].offsetParent !== null || els[i].getClientRects().length) return true; }
      return false;
    }
    function setAuto(box, show) {
      box.hidden = !show;
      box.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !show; });
    }
    function checkAuto() {
      if (!window.__zpAutoDone) return;
      // Once another personaliser has been seen, stop measuring the page (saves work on every tap).
      if (!window.__zpAutoOff && otherShown()) window.__zpAutoOff = true;
      document.querySelectorAll('[data-zp-pz-auto]').forEach(function (box) {
        if (window.__zpAutoOff) { if (!box.hidden || !box.__zpSet) { setAuto(box, false); box.__zpSet = true; } return; }
        if (box.hidden) { setAuto(box, true); box.__zpSet = true; }
      });
    }
    function startAuto() {
      var boxes = document.querySelectorAll('[data-zp-pz-auto]');
      if (!boxes.length) return;
      boxes.forEach(function (b) { b.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = true; }); });
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (otherShown() || tries >= 8) {
          clearInterval(t);
          window.__zpAutoDone = true;
          checkAuto();
        }
      }, 400);
      // Checks at most every 300 ms, not on every page change.
      var q = false;
      new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; checkAuto(); }, 300); }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'complete') startAuto(); else window.addEventListener('load', startAuto, { once: true });

    function init() { document.querySelectorAll('[data-zp-pz]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
    // Changing a variant can redraw the Add to cart area; set up any new copy of the box.
    var qi = false;
    new MutationObserver(function () {
      if (qi) return; qi = true;
      requestAnimationFrame(function () { qi = false; if (document.querySelector('[data-zp-pz]:not(.zp-pz--ready)')) init(); });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
